import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { Shape } from "@/types/diagram";
import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

interface UpdateShapePayload {
  _id?: string;
  name: string;
  description?: string;
  version?: string;
  tags?: string[];
  status?: "active" | "inactive";
  category: string;
  svgContent?: string;
}

export async function updateShape(payload: UpdateShapePayload & { token: string }): Promise<Shape> {
  const { token, ...shapeData } = payload;
  const url = `${config.isometricApiUrl}/shapes/${payload._id}`;

  try {
    const response = await apiFetch(url, {
      method: "PUT",
      body: JSON.stringify(shapeData),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to update shape: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating shape:", error);
    throw error;
  }
}

export default function useUpdateShapeService(
  onSettled?: (res: Shape | undefined, error: Error | null) => void
) {
  const { getAuthHeaders } = useAuthHeaders();
  
  return useMutation({
    mutationFn: (payload: UpdateShapePayload) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace('Bearer ', '');
      return updateShape({ ...payload, token });
    },
    onSettled,
  });
}